import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { BaseComponent } from '../base.component'
import { Customer, Writer, Post, Account } from '../../types'
import { customerPostStates } from 'src/logic/post-states'
import { QueryRef } from 'apollo-angular'
import { Data, WriterAccountPostsListQueries } from './writer-account-posts-list.queries'
import { get } from 'lodash-es'

@Component({
  selector: 'writer-account-posts-list',
  template: `
    <!-- EMPTY STATE -->
    <div *ngIf="!postsLoading && pages() === 1 && posts?.length === 0" class="profile-published-comment">
      You currently do not have any posts by this writer.
    </div>

    <div class="row mt-3">
      <div class="col-12" [class.top-buffer]="pages() === 1">
        <pagination-links *ngIf="pages() > 1" [currentPage]="getPage()" [pages]="pages()" [name]="'accountPostsPage'"
                          [route]="['/dashboard', customer.id, 'writer_profile', writer.slug]"></pagination-links>

        <div class="loader" *ngIf="postsLoading">Loading...</div>

        <ng-template [ngIf]="!postsLoading">
            <div *ngFor="let post of posts; trackBy trackById" class="mb-3">
              <post-box
                [customer]="post.customer"
                [post]="post"
                [showCustomer]="true"
                (deprecatedStoreChange)="onDeprecatedStoreChange($event)"></post-box>
            </div>
        </ng-template>

        <pagination-links *ngIf="pages() > 1" [currentPage]="getPage()" [pages]="pages()" [name]="'accountPostsPage'"
                          [route]="['/dashboard', customer.id, 'writer_profile', writer.slug]"></pagination-links>
      </div>
    </div>
  `
})
/**
 * Component: WriterCustomersPostsList
 * ====================================
 * Displays the post list by a writer for a customer or all customers on the account.
 * ALWAYS takes a customer input since this can currently only be displayed on a writer-profile in the context of a customer
 * If given ACCOUNT input, will load and display the posts for the entire account (all customers) instead of for 1 customer
 */
export class WriterAccountPostsList extends BaseComponent implements OnInit {
  @Input() writer: Writer;
  @Input() customer: Customer;
  @Input() account: Account;
  @Input() tab: string;
  @Input() accountList: boolean = false;
  postsLoading: boolean;
  accountPostsPage: number;
  posts: Post[]
  totalPosts: number = 0
  queryRef: QueryRef<Data>

  constructor(
    private route: ActivatedRoute,
    private queries: WriterAccountPostsListQueries
    ) {
    super()
  }

  ngOnInit(): void {
    const paramsObs = this.route.parent.queryParams.subscribe(queryParams => {
      this.accountPostsPage = +queryParams['accountPostsPage'] || 1
      if (this.writer && this.customer && this.account) {
        this.queryRef = this.queries.mainQuery({
          writerId: this.writer.id,
          page: this.accountPostsPage,
          perPage: 20,
          states: customerPostStates,
          order: 'lastTransitionAt DESC'
        })
        this.queryRef.valueChanges.subscribe(({loading, data, stale}) => {
          this.postsLoading = loading && stale
          if (data) {
            this.posts = get(data, 'account.posts.entries', [])
            this.totalPosts = get(data, 'account.posts.totalCount', 0)
          }
        })
      }
    })
    this.observers.push(paramsObs)
  }

  getPage(): number {
    return this.accountPostsPage || 1
  }

  pages(): number {
    const total = this.totalPosts
    if (total) {
      return Math.ceil(total / 20)
    } else {
      return 1
    }
  }

  onDeprecatedStoreChange(postId: number): void {
    //TODO: update only this post if postId provided
    this.queryRef.refetch()
  }

  trackById(index: number, post: Post): number {
    return post.id
  }

}
